import React, { ChangeEvent, ReactElement } from "react";
import styles from "./styles.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { handleOddsTypeChange } from "redux/config/configSlice";
import { Translate } from "react-redux-i18n";

interface IProps {
  handleClose: () => void
}

export default function OddsType({ handleClose }: IProps): ReactElement {
  const dispatch = useAppDispatch()
  const oddsType = useAppSelector(state => state.config.oddsType)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(handleOddsTypeChange({ type: (event.target as HTMLInputElement).value, label: (event.target as HTMLInputElement).name }))
    handleClose()
  }

  return (
    <Accordion className={styles.accordion}>
      <AccordionSummary className={styles.accordionSummary}>
        <Box className={styles.accordionSummaryContent}>
          <Typography className={styles.accordionLabel}><Translate value="nav.oddsType" /></Typography>
          <Typography className={styles.accordionLabel}>{oddsType.label}</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails className={styles.accodrionDetails}>
        <FormControl className={styles.form}>
          <RadioGroup value={oddsType.type} onChange={handleChange} className={styles.radioGroup}>
            <FormControlLabel value="decimal" control={<Radio />} label={<Translate value="config.decimal" />} name="DEC" className={styles.label} />
            <FormControlLabel value="american" control={<Radio />} label={<Translate value="config.american" />} name="USA" className={styles.label} />
            <FormControlLabel value="fraction" control={<Radio />} label={<Translate value="config.fractional" />} name="FRA" className={styles.label} />
          </RadioGroup>
        </FormControl>
      </AccordionDetails>
    </Accordion>
  )
}